import { useMemo } from 'react';
import {
	useViewPreference,
	FIELDS_DETAIL_PREFERENCE,
	FIELDS_PREFERENCE,
	type FieldsDetailPreference,
} from '@atlassian/jira-business-preferences';
import { useJWMListFeatures } from '../../features-context';
import { getInitVisibleFields } from '../constants';

export const useFieldsPreference = () => {
	const [fields, setFieldsOld] = useViewPreference(FIELDS_PREFERENCE);
	const [fieldsDetail, setFields] = useViewPreference(FIELDS_DETAIL_PREFERENCE);
	const { isBusinessFieldsEnabled, isScrumProject } = useJWMListFeatures();

	const fieldsPreferences = useMemo<FieldsDetailPreference>(() => {
		if (fieldsDetail == null && fields != null) {
			return {
				order: fields,
				details: null,
			};
		}

		if (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) {
			return {
				order: getInitVisibleFields({
					isCategoryEnabled: isBusinessFieldsEnabled,
					isScrumProject,
				}),
				details: null,
			};
		}

		return fieldsDetail;
	}, [fieldsDetail, fields, isBusinessFieldsEnabled, isScrumProject]);

	return [fieldsPreferences, setFields, setFieldsOld] as const;
};

export const useFieldsPreferenceOld = () => {
	const [fields, setFields] = useViewPreference(FIELDS_PREFERENCE);
	const { isBusinessFieldsEnabled, isScrumProject } = useJWMListFeatures();

	const fieldsPreferences: string[] = useMemo(() => {
		if (fields == null || !Array.isArray(fields)) {
			return getInitVisibleFields({
				isCategoryEnabled: isBusinessFieldsEnabled,
				isScrumProject,
			});
		}
		return fields;
	}, [fields, isBusinessFieldsEnabled, isScrumProject]);

	return [fieldsPreferences, setFields] as const;
};
